export default {
  log: (...args) => {
    console.log(...args); // eslint-disable-line
  },
  error: (...args) => {
    console.error(...args); // eslint-disable-line
  },
  warn: (...args) => console.warn(...args), //eslint-disable-line
};



// WEBPACK FOOTER //
// ./src/logger.js